import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import PositionList from '../Form/Control/PositionList.jsx'
import { usePickingControlDataState } from '../../../stores/PickingControlDataProvider.js'
import MetaInfoBlock from '../Form/MetaInfoBlock.jsx'

const PickingControlContentArea = () => {
  const {
    formErrors,
    headerData,
    resetErrorByFormKey,
    positions,
    loadOrderData,
    splitPosition,
    setPositions, checkPosition,
  } = usePickingControlDataState()
  return (
    <Form>
      {
        !loadOrderData
          ?
          <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
          :
          <>
            <div className='container-fluid'>
            <MetaInfoBlock headerData={headerData}/>
            <div className="mb-5" />
            <PositionList splitPosition={splitPosition} positions={positions} setPositions={setPositions} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} checkPosition={checkPosition}/>
            </div>
          </>
      }
    </Form>
  )

}

export default PickingControlContentArea

